<template>
    <TransitionRoot :show="isShowing" 
                    enter="transition-opacity duration-75"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="transition-opacity duration-150"
                    leave-from="opacity-100"
                    leave-to="opacity-0" 
                    class="error-toast"
                    :class="{ warning: toastType && toastType === 'warning'}" >
                    <div v-if="toastType && toastType === 'warning'" class="icon-container warning">
                        <ExclamationTriangleIcon class="icon icon-x-small icon-warning" />
                    </div>   
                    <div v-else class="icon-container">
                        <XMarkIcon class="icon icon-x-small icon-error" />        
                    </div>
                    <div class="error-content" :class="{ warning: toastType && toastType === 'warning'}">
                        <p>{{title}}</p>
                        <p>{{subtitle}}</p>
                    </div>
    </TransitionRoot>
</template>
<script setup lang="ts">
    import { defineProps } from 'vue';
    import { XMarkIcon } from '@heroicons/vue/24/outline';
    import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';
    import { TransitionRoot } from '@headlessui/vue'
    defineProps<{
        title: string    
        subtitle?: string
        isShowing: boolean
        toastType?: string
    }>()
    
</script>
<style lang="scss" scoped>
.error-toast {
    display: inline-flex;
    margin: 1.5rem 0rem -1rem;
    justify-content: space-between;
    padding: 1rem;
    border: 2px solid $salmon-light;
    border-radius: 15px;
    align-items: center;
    background-color: #fcefec;
    &.warning {
        border: 2px solid #f3e0bd;
        background-color: $warning-light;
    }
    .icon-container {
        border-radius: 50%;
        background-color: white;
        border: 10px solid $one-five-orange;
        box-shadow: $card-shadow;
        padding: 0.4rem;
        &.warning {
            border: 10px solid $warning-strong;
        }
    }
    .icon-error {
        stroke: $one-five-orange;
        stroke-width: 3px;
    }
    .icon-warning {
        stroke: $warning-strong;
        stroke-width: 2px;
    }
    .error-content{
        margin: 0 1rem 0;
        font-size: 0.8rem;
        color: $font-color;
        line-height: 1.3;
        text-transform: uppercase;
        &.warning { text-transform: none; }
        p:first-child {
            color: $font-color-dark;
            font-weight: 600;
            text-transform: none;
            font-size: 0.9rem;
        }
    }
}
    
</style>